import { TimeTrackingInfo } from '../../../common/AnalyticsContext/TrackingData';
import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { GenderChoice } from '../../../common/components/SearchHeader/types/GenderChoice';
import { LocationChoice } from '../../../common/components/SearchHeader/types/LocationChoice';

export const getlocationChoiceTrackingType = (locationChoice?: LocationChoice) => {
  if (!locationChoice) return undefined;
  if ('metro' in locationChoice) return 'region';
  if ('suburb' in locationChoice) return 'suburb';
  if ('state' in locationChoice) return 'state';
  return undefined;
};

export const analyticsGender = (choice: GenderChoice | undefined) => {
  if (choice === GenderChoice.MALE) return 'M';
  if (choice === GenderChoice.FEMALE) return 'F';
  return 'All';
};

export const renderDateFilter = (filters: FilterChoice) => {
  const date = filters.onlineAppointments?.date;

  if (!date) return 'NextAvailable';
  if (typeof date === 'string') return date;

  return date.end ? `${date.start} to ${date.end}` : date.start;
};

export const renderTimeFilter = (filters: FilterChoice): TimeTrackingInfo | undefined => {
  const time = filters.onlineAppointments?.time;

  switch (time) {
    case 'AM':
      return {
        modifierSelected: 'AM',
        startTime: '00',
        endTime: '12',
      };
    case 'PM':
      return {
        modifierSelected: 'PM',
        startTime: '12',
        endTime: '18',
      };
    case 'AFTER_HOURS':
      return {
        modifierSelected: 'AH',
        startTime: '18',
        endTime: '00',
      };
    default:
      return undefined;
  }
};
